import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { isString } from 'lodash';
import moment from 'moment';

const useStyles = makeStyles({
  root: {
    width: '100% !important',
    marginTop: '5px',
    minWidth: '200px !important',
  },
  helperText: {
    marginLeft: 0,
    fontSize: '12px',
    color: '#FC2C32',
  },
});

const StyledTextField = styled(TextField)(({ error, theme, customMargin, height }) => ({
  fontSize: '12px',
  '& .MuiOutlinedInput-root': {
    background: theme.palette.KenColors.CttSecondary ?? '#F5F7FB',
    borderRadius: '10px',
    fontSize: '14px',
    fontWeight: '500',
    height: height ? `${height} !important` : 'auto',
    color: '#212B38',
    margin: customMargin ? '4px 0px' : '0px',
    input: {
      '&::placeholder': {
        fontWeight: '500',
        color: '#8C8E94',
        opacity: 1,
      },
    },
    '& fieldset': {
      border: 'none',
    },
    '&:hover fieldset': {
      border: error ? `1px solid ${theme.palette.KenColors.statusRed}` : 'none',
    },
    '&.Mui-focused fieldset': {
      border: `1.5px solid ${error ? theme.palette.KenColors.statusRed : theme.palette.KenColors.CttPrimary}`,
    },
  },
}));

export default function KenTextFieldText(props) {
  const {
    FormHelperTextProps,
    InputLabelProps,
    inputProps,
    InputProps,
    SelectProps,
    className,
    children,
    disableKeyDown,
    minDate,
    maxDate,
    name,
    value,
    remaining = false,
    maxCharacters,
    dateType = 'year',
    withValue,
  } = props;
  const classes = useStyles();

  return (
    <StyledTextField
      className={`${className}`}
      classes={{ root: classes.root }}
      InputLabelProps={{ shrink: false, ...InputLabelProps }}
      inputProps={{
        ...inputProps,
        style: { height: '135px' },
      }}
      InputProps={{
        components: 'p',
        className: classes.inputStyles,
        ...InputProps,
        inputProps: {
          min:
            minDate &&
            minDate !== null &&
            (minDate === true
              ? moment().format('YYYY-MM-DD')
              : isString(minDate)
              ? minDate
              : withValue
              ? moment(value).subtract(Number(minDate), dateType).format('YYYY-MM-DD')
              : moment().subtract(Number(minDate), dateType).format('YYYY-MM-DD')),
          max:
            maxDate &&
            maxDate !== null &&
            (maxDate === true
              ? moment().format('YYYY-MM-DD')
              : withValue
              ? moment(value).add(Number(maxDate), dateType).format('YYYY-MM-DD')
              : moment().add(Number(maxDate), dateType).format('YYYY-MM-DD')),
          'data-testid': `test-${name}`,
        },
      }}
      FormHelperTextProps={{
        className: classes.helperText,
        ...FormHelperTextProps,
      }}
      {...props}
      SelectProps={{
        MenuProps: {
          PaperProps: {
            style: {
              maxHeight: '300px',
            },
          },
        },
        ...SelectProps,
      }}
      onKeyDown={(e) => {
        disableKeyDown && e.preventDefault();
      }}
      label=""
      helperText={<>{remaining === true && <p style={{ color: '#505F79', marginTop: '-2px' }}>Remaining Characters: {maxCharacters - (value?.length || 0)}</p>}</>}
    >
      {children}
    </StyledTextField>
  );
}
